import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ButtonModule } from "primeng/button";
import { TranslateModule } from "@ngx-translate/core";
import { PasswordModule } from "primeng/password";
import { InputTextModule } from "primeng/inputtext";
import { CheckboxModule } from "primeng/checkbox";
import { ToastModule } from "primeng/toast";
import { RippleModule } from "primeng/ripple";
import { AccordionModule } from "primeng/accordion";
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from "primeng/dropdown";
import { MessagesModule } from "primeng/messages";
import { QRCodeModule } from 'angularx-qrcode';
import { YouTubePlayerModule } from "@angular/youtube-player";
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ImageCropperModule } from "ngx-image-cropper";
import { InputSwitchModule } from 'primeng/inputswitch';
import { NgxFileDropModule } from 'ngx-file-drop';
import { CalendarModule } from 'primeng/calendar';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { HttpClientModule } from '@angular/common/http';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { AnalyticsDateRangePickerComponent } from 'src/app/user/card/analytics-date-range-picker/analytics-date-range-picker.component';
import { CardPreviewComponent } from 'src/app/user/card/card-add/card-preview/card-preview.component';

import { AlertsComponent, LanguageComponent, SocialShareComponent, YoutubePlayerComponent, ImageCropperComponent, ToastComponent, WebpImageComponent, ContactInfoComponent, SocialIconsComponent, GradientPickerDialogComponent, ProductCarouselComponent, ProductCarouselOtherComponent } from './components';
import { CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe, ContactPipe, SafeUrlPipe, EnvironmentPipe } from './pipes';
import { PhoneNumberDirective } from './directives';

const COMPONENTS = [
  AlertsComponent,
  LanguageComponent,
  YoutubePlayerComponent,
  SocialShareComponent,
  ImageCropperComponent,
  ToastComponent,
  WebpImageComponent,
  ContactInfoComponent,
  SocialIconsComponent,
  GradientPickerDialogComponent,
  ProductCarouselComponent,
  ProductCarouselOtherComponent,
  AnalyticsDateRangePickerComponent,
  /* Hosted here so Integrations can render a card template preview without
     importing the whole card-add wizard. */
  CardPreviewComponent,
];
const PIPES = [
  CapitalizePipe,
  PluralPipe,
  RoundPipe,
  TimingPipe,
  NumberWithCommasPipe,
  ContactPipe,
  SafeUrlPipe,
  EnvironmentPipe
];
const DIRECTIVES = [
  PhoneNumberDirective
]
@NgModule({
  declarations: [...COMPONENTS, ...PIPES, ...DIRECTIVES,],
  imports: [
    CommonModule, ReactiveFormsModule, FormsModule, HttpClientModule,
    TranslateModule,
    PasswordModule, InputTextModule, ButtonModule, CheckboxModule, ToastModule,
    RippleModule, AccordionModule, DialogModule, DropdownModule, MessagesModule, QRCodeModule, YouTubePlayerModule,
    FontAwesomeModule, ImageCropperModule, SelectButtonModule, InputSwitchModule, NgxFileDropModule, CalendarModule, PaginatorModule, TooltipModule, NgxDaterangepickerMd
  ],
  exports: [CommonModule, ReactiveFormsModule, FormsModule, ButtonModule, TranslateModule, PasswordModule,
    InputTextModule, HttpClientModule, CheckboxModule, ToastModule, RippleModule, AccordionModule, DialogModule,
    DropdownModule, MessagesModule, QRCodeModule, YouTubePlayerModule, FontAwesomeModule,
    ImageCropperModule, InputSwitchModule, SelectButtonModule, NgxFileDropModule, CalendarModule, PaginatorModule, TooltipModule, NgxDaterangepickerMd, ...COMPONENTS, ...PIPES, ...DIRECTIVES],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {
}
